"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsEs = void 0;
exports.aclTranslationsEs = {
    // ACL Resources
    'acl_resource.company': 'Empresa',
    'acl_resource.user': 'Usuario',
    'acl_resource.user_group': 'Grupo de Usuarios',
    'acl_resource.settings_general': 'Configuración General',
    'acl_resource.settings_access': 'Configuración de Acceso',
    'acl_resource.settings_styles': 'Configuración de Estilos',
    'acl_resource.avatar': 'Avatar',
    'acl_resource.ai': 'IA',
    'acl_resource.knowledge': 'Conocimiento',
    'acl_resource.project': 'Proyecto',
    'acl_resource.onboarding': 'Incorporación',
    'acl_resource.reports': 'Informes',
    // ACL Actions
    'acl_action.read': 'Leer',
    'acl_action.write': 'Escribir',
    'acl_action.delete': 'Eliminar',
};
